// @ts-nocheck
import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook to detect if the content of an element overflows horizontally.
 *
 * @param {React.RefObject} ref - A React ref pointing to a DOM element whose overflow is to be checked.
 * @param {*} dependency - A dependency that triggers re-evaluation (e.g., display value changes).
 * @returns {boolean} - Returns `true` if the element's content is overflowing, otherwise `false`.
 *
 * Useful for conditionally showing tooltips or ellipsis based on text overflow.
 */

const useTextOverflow = (dependency) => {
  const ref = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const element = ref?.current;
    if (!element) return;

    // Function to check if content overflows horizontally
    const checkOverflow = () => {
      const isOver = element.scrollWidth > element.clientWidth;
      setIsOverflowed(isOver);
    };

    checkOverflow(); // Initial check on mount or dependency change

    // Observe resizing of the element to re-check overflow
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);

    // Cleanup the observer on unmount or dependency change
    return () => observer.disconnect();
  }, [dependency]);

  return { ref, isOverflowed };
};

export default useTextOverflow;
